import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="history"
export default class extends Controller {
  static targets = ["form", "search", "map", "controls", "playbackPosition", "positionsCount", "alert"]
  static values = { canDeleteRouter: Boolean, routerLabels: Object }
  map = null
  locations = []
  currentPositionIndex = 0
  positions = []
  displayRouter = null

  connect() {
    this.renderMap();
  }

  search(event) { 
    event.preventDefault()
    this.removeAllMarkers()
    this.removeAllCircles()
    this.closeAllInfoWindows()
    const url = this.formTarget.action + "?" + new URLSearchParams(new FormData(this.formTarget)).toString()
    history.pushState(null, "", url.replace(".json", ""))
    fetch(url, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json",
      }
    })
      .then(response => response.json())
      .then(json => {
        console.log(json)
        this.setLocations(json)
        
        this.renderPosition(this.currentPositionIndex)
      })
  }

  backward(event) {
    event.preventDefault()
    if (this.currentPositionIndex > 0) {
      this.currentPositionIndex--
      this.renderPosition(this.currentPositionIndex)
      this.playbackPositionTarget.innerHTML = this.currentPositionIndex + 1
    }
  }

  forward(event) {
    event.preventDefault()
    if (this.currentPositionIndex < this.locations.length - 1) {
      this.currentPositionIndex++
      this.renderPosition(this.currentPositionIndex)
      this.playbackPositionTarget.innerHTML = this.currentPositionIndex + 1
    }
  }

  setLocations(locations) {
    this.locations = locations
    this.setPositions(this.locations)

    if (this.locations.length > 0) {
      this.currentPositionIndex = 0
      this.renderControls()
      this.alertTarget.setAttribute("style", "display: none;")
    } else {
      this.alertTarget.removeAttribute("style")
      this.hideControls()
    }

    return this.locations
  }

  setPositions(locations) {
    if (locations.length == 0) {
      this.positions = []
      return
    }
    
    this.positions = locations.map(location => {
      var meta = location.meta_data != null ? JSON.parse(location.meta_data) : {}
      var time = new Date(location.last_location_update)

      return {
        latlng: new google.maps.LatLng(location.lat, location.lng),
        type: location.type.toLocaleLowerCase(),
        time: time.toLocaleString(),
        meta: meta,
        signal: location.signal_strength,
        accuracy: location.satelite_count,
        battery: location.battery_level,
        routers: location.routers || [],
        info_window: this.infoWindowFor(location),
        polylines: [],
      }
    })

    return this.positions
  }

  infoWindowFor(location) {
    var meta = location.meta_data != null ? JSON.parse(location.meta_data) : {}
    var accuracy = meta.accuracy_meters || "0"
    accuracy = parseFloat(accuracy).toFixed(2)
    var time = new Date(location.last_location_update).toLocaleString()
    return `
      <div class="infowindow-content">
        <div class="header">
          <div class="row">
            <div class="col-12">
              <i class="fa fa-clock-o"></i> ${time}
            </div>
          </div>
        </div>

        <div class="container">
          <div class="row">
            <div class="col-12">
              <p>
                <i class="fa fa-crosshairs"></i> ${accuracy}m &nbsp; &nbsp;
                <i class="fa fa-signal"></i> ${location.signal_strength} &nbsp; &nbsp; 
                <i class="fa fa-globe"></i> ${location.satelite_count} &nbsp; &nbsp;
                <i class="fa fa-battery-${Math.ceil(location.battery_percentage / 20) - 1}"></i> ${location.battery_percentage}
              </p>
            </div>
          </div>
        </div>
      </div>
    `
  }

  panTo(event) {
    var mac_address = event.params.macAddress
    console.log(event)
    this.locations[this.currentPositionIndex].routers.forEach(router => {
      if (router.mac_address == mac_address) {
        var lats = router.locations.map(location => location.lat)
        var lngs = router.locations.map(location => location.lng)
        var lat = lats.reduce((a, b) => a + b, 0) / lats.length
        var lng = lngs.reduce((a, b) => a + b, 0) / lngs.length
        this.map.panTo(new google.maps.LatLng(lat, lng))
      }
    });
  }

  filterRouter(event) {
    var mac_adres = event.params.macAddress
    this.displayRouter = mac_adres;
    this.renderRouters(this.currentPositionIndex)
  }

  unfilterRouter(event) {
    this.displayRouter = null
    this.renderRouters(this.currentPositionIndex)
  }

  infowindowRouters(location) {
    return location.routers.map(router => {
      var average_accuracy = (router.locations.map(location => parseFloat(location.accuracy)).reduce((a, b) => a + b, 0) / router.locations.length).toFixed(2)
      return `
        <div class="row">
          <div class="col-12" style="cursor: pointer" data-action="click->history#panTo mouseenter->history#filterRouter mouseout->history#unfilterRouter" data-history-mac_address-param='${router.mac_address}'">
            <span style="color: ${router.color}"> 
              <i class="fa fa-wifi"></i> ${router.mac_address} (${router.name})&nbsp; &nbsp;
              <i class="fa fa-map-marker"></i>
              - ${router.locations.length}
              - ${average_accuracy}m
            </span>
          </div>
        </div>
      `
    }).join("") || "";
  }
  
  renderRouterList(location) {
    const container = document.getElementById('router_list')
    container.innerHTML = ''

    if (!location || !location.routers || location.routers.length === 0) {
      const empty = document.createElement('li')
      empty.className = 'history-router-list__empty'
      empty.textContent = this.routerLabelsValue.empty
      container.appendChild(empty)
      return
    }

    location.routers.forEach(router => {
      const li = document.createElement('li')
      li.className = 'history-router-list__item'
      li.setAttribute('data-action', 'mouseenter->history#filterRouter mouseleave->history#unfilterRouter')
      li.setAttribute('data-history-mac-address-param', router.mac_address)
      const avgAcc = (router.locations.map(l => parseFloat(l.accuracy)).reduce((a, b) => a + b, 0) / router.locations.length).toFixed(1)

      li.innerHTML = `
        <button type="button" class="history-router-list__details"
          data-action="click->history#panTo focus->history#filterRouter blur->history#unfilterRouter">
          <span class="history-router-list__icon"><i class="fa fa-wifi" aria-hidden="true"></i></span>
          <span class="history-router-list__info">
            <span class="history-router-list__name"></span>
            <span class="history-router-list__mac"></span>
          </span>
          <span class="history-router-list__accuracy"><i class="fa fa-map-marker" aria-hidden="true"></i> <span></span></span>
        </button>
        <button type="button" class="btn btn-sm btn-outline-metal history-router-list__copy"
          data-action="click->history#copyRouterMac"><i class="fa fa-copy" aria-hidden="true"></i></button>
        ${this.canDeleteRouterValue ? `<button type="button" class="btn btn-sm btn-outline-danger history-router-list__delete"
          data-action="click->history#deleteRouter"
          ><i class="fa fa-trash" aria-hidden="true"></i></button>` : ''}
      `
      const details = li.querySelector('.history-router-list__details')
      details.setAttribute('data-history-mac-address-param', router.mac_address)
      details.title = this.routerLabelsValue.show_on_map
      li.querySelector('.history-router-list__icon').style.color = router.color
      li.querySelector('.history-router-list__name').textContent = router.name || this.routerLabelsValue.unnamed
      li.querySelector('.history-router-list__mac').textContent = router.mac_address

      const accuracy = li.querySelector('.history-router-list__accuracy')
      accuracy.title = this.routerLabelsValue.accuracy
      accuracy.setAttribute('aria-label', `${this.routerLabelsValue.accuracy}: ${avgAcc} m`)
      accuracy.querySelector('span').textContent = `${avgAcc} m`

      const copyButton = li.querySelector('.history-router-list__copy')
      copyButton.setAttribute('data-history-mac-param', router.mac_address)
      copyButton.title = this.routerLabelsValue.copy
      copyButton.setAttribute('aria-label', this.routerLabelsValue.copy)
      
      const deleteButton = li.querySelector('.history-router-list__delete')
      if (deleteButton) {
        deleteButton.setAttribute('data-history-mac-param', router.mac_address)
        deleteButton.title = this.routerLabelsValue.delete
        deleteButton.setAttribute('aria-label', this.routerLabelsValue.delete)
      }
      container.appendChild(li)
    })
  }

  async copyRouterMac(event) {
    const button = event.currentTarget
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(event.params.mac)
      } else {
        const input = document.createElement('textarea')
        input.value = event.params.mac
        input.style.position = 'fixed'
        input.style.opacity = '0'
        document.body.appendChild(input)
        try {
          input.select()
          if (!document.execCommand('copy')) throw new Error('Copy failed')
        } finally {
          input.remove()
          button.focus()
        }
      }
      button.innerHTML = '<i class="fa fa-check text-success" aria-hidden="true"></i>'
      button.title = this.routerLabelsValue.copied
      button.setAttribute('aria-label', this.routerLabelsValue.copied)
      setTimeout(() => {
        button.innerHTML = '<i class="fa fa-copy" aria-hidden="true"></i>'
        button.title = this.routerLabelsValue.copy
        button.setAttribute('aria-label', this.routerLabelsValue.copy)
      }, 1500)
    } catch (error) {
      alert(this.routerLabelsValue.copy_failed)
    }
  }

  deleteRouter(event) {
    if (!this.canDeleteRouterValue) return

    const mac = event.params.mac
    if (!confirm(this.routerLabelsValue.confirm_delete.replace('%{mac}', () => mac))) return

    fetch(`/igps/remove_router/${encodeURIComponent(mac)}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ mac })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          this.locations.forEach(location => {
            if (location.routers) {
              location.routers = location.routers.filter(r => r.mac_address !== mac);
            }
          });
          this.positions.forEach(positions => {
            if (positions.routers) {
              positions.routers = positions.routers.filter(r => r.mac_address !== mac);
            }
          });
          if (this.currentPositionIndex != null) {
            this.renderPosition(this.currentPositionIndex);
          }
        } else {
          alert(this.routerLabelsValue.delete_failed)
        }
      })
      .catch(err => {
        console.error('Router removal error:', err)
        alert(this.routerLabelsValue.connection_error)
      })
  }

  renderMap() {
    if (this.map == null) {
      var latlng = new google.maps.LatLng(52.1326, 5.2913);
      this.map = new google.maps.Map(this.mapTarget, 
        {
          center: latlng,
          zoom: 15,
          mapId: 'DEMO_MAP_ID'
        }
      )
    } else {
      console.log("Map already rendered")
    }
  }

  renderPolyLine(index) {
    if (this.positions.length == 0 || index < 1) {
      return
    }

    const position = this.positions[index]
    if (position.polyline != null) {
      position.polyline.setMap(null)
    }

    var start_path = this.positions[index - 1].latlng
    var end_path = position.latlng
    var polyline = new google.maps.Polyline({
      path: [start_path, end_path],
      geodesic: true,
      strokeColor: app.device_history.data_type_to_color(position.type.toLowerCase()),
      strokeOpacity: 0.7,
      strokeWeight: 2
    });

    position.polylines.push(polyline)
    polyline.setMap(this.map)
  }

  renderPosition(index) {
    if (this.positions.length == 0) {
      return
    }

    const position = this.positions[index]
    this.map.setCenter(position.latlng)

    if (position.marker != null) {
      position.marker.setMap(null)
    }
    position.marker = new google.maps.Marker({
      position: position.latlng,
      map: this.map,
      title: position.time,
      icon: app.icons[position.type],
      zIndex: index
    });

    this.closeAllInfoWindows()
    var infowindow = new google.maps.InfoWindow({
      content: position.info_window
    });

    position.infowindow = infowindow
    infowindow.open(this.map, position.marker);
    this.renderRouters(index);
    this.renderPolyLine(index);
    this.renderRouterList(position);
  }

  renderRouters(index) {
    if (this.positions.length == 0) {
      return
    }
    const position = this.positions[index]
    
    this.removeAllCircles();

    position.router_location_circles = [];
    
    this.locations[index].routers.map(router => {
      if (this.displayRouter != null && this.displayRouter != router.mac_address) {
        return
      }
      return router.locations.map(location => {
        var circle = new google.maps.Circle({
          strokeColor: router.color,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: router.color,
          fillOpacity: 0.15,
          title: router.mac_address,
          map: this.map,
          center: new google.maps.LatLng(location.lat, location.lng),
          radius: parseFloat(location.accuracy)
        });

        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(location.lat, location.lng),
          map: this.map,
          title: router.mac_address + " - " + location.accuracy + "m",
          icon: app.icons["none"],
          zIndex: index
        });
        position.router_location_circles.push({shape: circle, marker: marker});
      });
    });
  }

  closeAllInfoWindows() {
    this.positions.forEach(position => {
      if (position.infowindow != null)
        position.infowindow.close()
    })
  }

  removeAllCircles() {
    this.positions.forEach(position => {
      if (position.router_location_circles != null) {
        position.router_location_circles.forEach(circle => {
          circle.shape.setMap(null);
          circle.marker.setMap(null)
        })
      }
    })
  }

  removeAllMarkers() {
    this.positions.forEach(position => {
      if (position.marker != null)
        position.marker.setMap(null)
    })
  }

  renderControls() {
    this.controlsTarget.removeAttribute("style")
    this.playbackPositionTarget.innerHTML = this.currentPositionIndex + 1;
    this.positionsCountTarget.innerHTML = this.locations.length;
  }

  hideControls() {
    this.controlsTarget.setAttribute("style", "display: none;")
  }
}
